import citizenPassportTranslations from './language.definitions'
export default citizenPassportTranslations
